<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <FooterBar v-if="$route.name !== 'Index'" />
    <ToTop v-show="showBackToTop" />
    <Asides v-if="isShallow()" />
    <CustomerService v-if="wxData && wxData.id"></CustomerService>
  </div>
</template>
<script>
import { mapActions } from "vuex"
import Header from "./components/Herder.vue"
import Asides from "./components/Asides.vue"
export default {
  name: 'App',
  components: { Header, Asides },
  data() {
    return {
      showBackToTop: false
    };
  },

  methods: {
    //借助mapActions生成对应的方法，方法中会调用dispatch去联系actions(数组写法)
    ...mapActions('home', ['getBanner', 'getCompany', 'getMenuBrand']),
    handleScroll() {
      const scrollTop = window.pageYOffset;
      // console.log(scrollTop)
      if (scrollTop > 1000) {
        this.showBackToTop = true
      } else {
        this.showBackToTop = false
      }
    },
    isShallow() {
      if (this.$route.name !== 'Index'
        && this.$route.name !== 'Contact'
        && this.$route.name !== 'Login'
        && this.$route.path.includes('/BigData') !== true
      ) {
        return true
      }
      else {
        return false
      }
    }
  },
  async mounted() {
    // console.log('我是app我在读取vux中的数据',this.wxData)
    // 引入微信公众平台SDK
    const script = document.createElement('script')
    script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    document.body.appendChild(script)

    // 获取轮播图
    this.getBanner()
    // 获取公司信息
    this.getCompany()
    // 获取二级分类图片
    this.getMenuBrand()
    // 绑定滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 解绑事件
    window.removeEventListener('scroll', this.handleScroll);
  },
}
</script>

<style lang="scss">
html {
  @font-face {
    font-family: 'JinBuTi';
    src: url('./assets/alifont/DingTalkJinBuTi.ttf'),
  }

  & {
    background-color: #ebe9e9 !important;
    font-size: 6vw;
    font-family: sans-serif, '微软雅黑', "Microsoft YaHei", "STXihei", "Helvetica","PingFang SC";
  }
}
body{
  font-family: sans-serif, '微软雅黑', "Microsoft YaHei", "STXihei", "Helvetica","PingFang SC";
}
a {
  position: relative;
}

.tipsinfoss {
  position: absolute;
  border-radius: 20px;
  padding: 2px;
  min-width: 17px;
  height: 17px;
  text-align: center;
  background-color: red;
  color: white !important;
  top: -10px;
  right: -10px;
  z-index: 9;
  font-size: 12px;
  font-weight: normal !important;
}
</style>
